import { render, staticRenderFns } from "./assetCardDetail.vue?vue&type=template&id=35c36150&scoped=true"
import script from "./assetCardDetail.vue?vue&type=script&lang=js"
export * from "./assetCardDetail.vue?vue&type=script&lang=js"
import style0 from "./assetCardDetail.vue?vue&type=style&index=0&id=35c36150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c36150",
  null
  
)

export default component.exports